import { render } from "./PolicyTable.vue?vue&type=template&id=75afeec8&scoped=true"
import script from "./PolicyTable.vue?vue&type=script&lang=js"
export * from "./PolicyTable.vue?vue&type=script&lang=js"

import "./PolicyTable.vue?vue&type=style&index=0&id=75afeec8&scoped=true&lang=scss"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75afeec8"]])

export default __exports__